import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { ImplementationState } from '../../implementation/state/implementation.state';
import { selectImplementation } from '../../implementation/state/implementation.selectors';
import * as ImplementationActions from '../../implementation/state/implementation.actions';
import { Observable, Subscription } from 'rxjs';
import { ImplementationViewModel } from 'projects/data/src/lib/model/implementationViewModel';
import { ImplementationDetailViewModel } from 'projects/data/src/lib/model/implementationDetailViewModel';
import { ActivatedRoute, Router } from '@angular/router';
import { ImplementationWrapperService } from '@core/services/service-wrappers/implementation-wrapper.service';
import { ConfigurationWrapperService } from '@core/services/service-wrappers/configuration-wrapper.service';
import { SessionStorageService } from '@core/services/session-storage.service';

@Component({
  standalone: false,
  selector: 'app-implementation-end',
  templateUrl: './implementation-end.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./implementation-end.component.scss']
})
export class ImplementationEndComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private implementationService: ImplementationWrapperService,
    private store: Store<ImplementationState>,
    private sessionStorageService: SessionStorageService,
    private configurationService: ConfigurationWrapperService
  ) {
    const cl = this.sessionStorageService.getItem('custom-logo') ?? '';

    if (cl !== '' && cl === 'opus_logo.png') {
      this.productName = 'Opus RCM';
      this.logoFile = 'OPUSrcm.svg';
    } else if (cl !== '') {
      this.logoFile = cl;
    } else {
      this.logoFile = this.default_logo_file;
    }
  }

  ngOnInit(): void {}

  public isImplementation: boolean = false;
  public gonext: boolean = false;
  public itemCount: number = 0;
  private activatedRouteSub: Subscription;
  private implementation$: Observable<ImplementationViewModel> = this.store.select(selectImplementation);
  private implementationSub: Subscription;
  private implementation: ImplementationViewModel = null;
  private implementationDetail: ImplementationDetailViewModel = null;
  private STEP_CODE = 'finish';
  logoFile = '';
  default_logo_file = 'peregrine-logo-white_black.svg';
  productName = 'Peregrine';

  implementationSubscribe() {
    this.activatedRouteSub = this.activatedRoute.data.subscribe((data) => {
      this.isImplementation = data.implementation;

      if (this.isImplementation) {
        this.implementationSub = this.implementation$.subscribe((i) => {
          this.implementation = i;
          this.implementationDetail = this.implementation.details.find(
            (d) => d.implementationStepCode == this.STEP_CODE
          );
        });
      }
    });
    this.store.dispatch(ImplementationActions.updateImplementationStep({ stepCode: this.STEP_CODE }));
  }

  implementationUnsubscribe() {
    if (this.isImplementation) {
      this.activatedRouteSub.unsubscribe();
      this.implementationSub.unsubscribe();
    }
  }

  next(): void {
    this.gonext = true;
    this.implementationService.apiV1ImplementationCompleteStepCodePost(this.STEP_CODE).subscribe(
      () => {
        this.gonext = false;
        window.location.href = '/accounts';
      },
      () => (this.gonext = false)
    );
  }
}
